import React, { useEffect, useState } from 'react';
import { Table, Typography } from 'antd';
import { showImport } from '@app/api/import.api';

const { Title } = Typography;

interface PackingListViewProps {
  import_id: string | null;
}

const PackingListView: React.FC<PackingListViewProps> = ({ import_id }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [productOptions, setProductOptions] = useState<{ value: number; label: string }[]>([]);

  useEffect(() => {
    if (!import_id) return;

    const fetchImportData = async () => {
      try {
        // Fetch data for import and product options
        const response = await showImport(Number(import_id));
        setProductOptions(response.pr_options || []);

        const formattedData =
          response?.import?.import_lines?.flatMap((importLine: any, lineIndex: number) => {
            return importLine.import_line_varieties.map((variety: any, varietyIndex: number) => ({
              key: `${lineIndex}-${varietyIndex}-${importLine.product_id}-${variety.product_variety_id}`,
              labVerification: variety.lab_verification,
              productSpecies: variety.L4?.species || 'Unknown',
              productVarieties: variety.product_variety?.name || 'Unknown',
              brandName: variety.L4?.brand_names,
              quantity: variety.quantity,
            }));
          }) ?? [];
        setTableData(formattedData);
      } catch (error) {
        console.error('Failed to fetch product options:', error);
      }
    };

    fetchImportData();
  }, [import_id]);

  const columns = [
    // { title: 'Lab Verification', dataIndex: 'labVerification' },
    { title: 'Product Species', dataIndex: 'productSpecies' },
    { title: 'Product Variety', dataIndex: 'productVarieties' },
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      render: (text: any) => (Array.isArray(text) ? text.join(', ') : text), // Check if it's an array before joining
    },
    { title: 'Quantity (Tons)', dataIndex: 'quantity' },
  ];

  return (
    <div>
      <Title level={4}>Packing List</Title>
      <Table columns={columns} dataSource={tableData} rowKey="key" pagination={false} style={{ marginTop: 20 }} />
    </div>
  );
};

export default PackingListView;
